// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jZhn_","question":"styles_question__MOzjD","description":"styles_description__34dHq"};